import React, { useEffect, useState } from 'react'
import { Link, IconButton, Box, Grid, Typography, Button, useMediaQuery } from '@material-ui/core'
import ArrowForwardIosIcon from '@material-ui/icons/ArrowForwardIos'
import { SectionHeaderSmall, TitleH2Bold, TitleMedium, BodySmall } from '../../theme/typography'
import CustomButton from '../Button/CustomButton'
import VideoModal from '../Video/VideoModal'
import ModalComponent from '../Other/ModalComponent'
import {
  CarouselProvider,
  Slider,
  Slide,
  ButtonBack,
  ButtonNext,
  DotGroup,
  Dot,
  WithStore
} from 'pure-react-carousel'
import 'pure-react-carousel/dist/react-carousel.es.css'
import PropTypes from 'proptypes'
import clsx from 'clsx'
import { makeStyles } from '@material-ui/core/styles'
import ReactHtmlParser from 'react-html-parser'
import ErrorBoundary from '../../errorBoundary'
import { placeImage, uppercaseString } from '../../utils'
import { isAndroid } from 'react-device-detect'
import { GatsbyImage } from 'gatsby-plugin-image'
import Svg from 'react-inlinesvg'
import WhiteCircle from '../../images/bgimages/white-circle.svg'

const useStyles = makeStyles((theme) => ({
  root: {
    position: 'relative',
    zIndex: 1,
    color: theme.colors.white,
    backgroundColor: (props) => (props.bgcolor ? theme.colors.blue1 : 'transparent'),
    maxWidth: 1200,
    margin: 'auto',
    marginBottom: (props) =>
      props.iPhone || props.iPad ? '14rem' : props.homepage ? -150 : 'auto',
    [theme.breakpoints.up('sm')]: {
      marginBottom: (props) =>
        props.iPhone || props.iPad ? '14rem' : props.homepage ? -90 : 'auto'
    },
    [theme.breakpoints.up('md')]: {
      marginBottom: (props) => (props.iPhone || props.iPad ? '-2rem' : 'auto'),
      marginTop: (props) => (props.watch ? '5em' : 'auto')
    }
  },
  buttons: {
    appearance: 'none',
    color: theme.colors.white,
    background: 'transparent',
    border: 'none',
    position: 'absolute',
    top: '50%',
    transform: 'translateY(-50%)'
  },
  ctas: {
    margin: theme.spacing(2, -1, 1, -1),
    display: 'flex',
    justifyContent: 'center',
    '@media (min-width: 960px)': {
      justifyContent: 'flex-start'
    },
    '& img': {
      display: 'block'
    },
    '& a': {
      margin: theme.spacing(1)
    }
  },
  left: {
    left: theme.spacing(1),
    [theme.breakpoints.up('lg')]: {
      left: -theme.spacing(3)
    }
  },
  right: {
    right: theme.spacing(1),
    [theme.breakpoints.up('lg')]: {
      right: -theme.spacing(3)
    }
  },
  nextItem: {
    position: 'relative',
    appearance: 'none',
    color: theme.colors.white,
    background: 'transparent',
    border: 'none',
    marginTop: theme.spacing(1),
    textAlign: 'left',
    outline: 'none',
    [theme.breakpoints.up('md')]: {
      marginBottom: theme.spacing(4)
    },
    '& > span': {
      padding: 0
    },
    '& .gatsby-image-wrapper': {
      marginRight: theme.spacing(1.5)
    },
    '& svg': {
      marginLeft: theme.spacing(0.5)
    }
  },
  customWhite: {
    color: theme.colors.blue5,
    backgroundColor: theme.colors.white,
    '& > span': {
      padding: theme.spacing(0, 2)
    },
    '&:hover': {
      color: theme.colors.blue5,
      backgroundColor: theme.colors.white
    }
  },
  indexIcon: {
    width: 20,
    height: 20,
    borderRadius: 10,
    boxShadow: '1px 1px 4px 0 rgb(0 0 0 / 30%)',
    backgroundImage: 'linear-gradient(135deg, #104c5f, #00313f)',
    color: theme.colors.white,
    position: 'absolute',
    top: -8,
    left: -5,
    textAlign: 'center',
    fontSize: 12,
    lineHeight: 1.7,
    zIndex: 2
  },
  nav: {
    color: theme.colors.blue5
  },
  hideMobile: {
    [theme.breakpoints.down('sm')]: {
      display: 'none'
    }
  },
  hideDesktop: {
    [theme.breakpoints.up('md')]: {
      display: 'none'
    }
  },
  gridContainer: {
    padding: theme.spacing(2),
    flexDirection: 'column',
    textAlign: 'center',
    [theme.breakpoints.up('md')]: {
      flexDirection: 'row-reverse',
      padding: theme.spacing(0, 6)
    }
  },
  minHeight: {
    width: (props) => (props.iPhone ? 202 : props.iPad ? 248 : 'auto'),
    margin: 'auto',
    [theme.breakpoints.up('sm')]: {
      width: (props) => (props.iPhone ? 248 : props.iPad ? 390 : 'auto'),
      minHeight: (props) => (props.iPad ? 510 : 50),
      marginBottom: (props) => (props.watch ? '8rem' : '0')
    },
    '& li': {
      minHeight: (props) => (props.homepage ? 255 : props.iPhone ? 526 : 400),
      [theme.breakpoints.up('sm')]: {
        minHeight: (props) => (props.homepage ? 515 : props.iPhone ? 526 : 400),
        minWidth: (props) => (props.homepage ? 450 : 200)
      },
      '& > div': {
        display: (props) => (props.watch ? 'flex' : 'block'),
        justifyContent: 'center',
        alignItems: 'center'
      }
    }
  },
  android: {
    width: '206px !important',
    [theme.breakpoints.up('sm')]: {
      width: '248px !important'
    }
  },
  textWrap: {
    textAlign: 'left',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center'
  },
  icon: {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%) scale(0.6) translateZ(0)',
    transition: 'transform .2s ease',
    WebkitBackfaceVisibility: 'hidden'
  },
  whiteCircle: {
    width: 62,
    height: 62,
    margin: 'auto',
    transition: 'width .2s ease'
  },
  dot: {
    position: 'relative',
    display: 'inline-block',
    border: 'none',
    backgroundColor: 'transparent',
    outline: 'none',
    width: 72,
    height: 72,
    opacity: 0.5,
    verticalAlign: 'middle',
    padding: 0,
    margin: 0,
    [theme.breakpoints.up('sm')]: {
      width: 92,
      height: 92
    },

    '&:hover': {
      opacity: 1,
      '& .icon': {
        transform: 'translate(-50%, -50%) scale(1)'
      },
      '& .white-circle': {
        width: 72,
        height: 72,
        [theme.breakpoints.up('sm')]: {
          width: 92,
          height: 92
        }
      }
    }
  },

  isSelected: {
    opacity: 1,
    '& .icon': {
      transform: 'translate(-50%, -50%) scale(1) translateZ(0)'
    },
    '& .white-circle': {
      width: 72,
      height: 72,
      [theme.breakpoints.up('sm')]: {
        width: 92,
        height: 92
      }
    }
  },
  textContent: {
    '& a': {
      color: theme.colors.white,
      textDecoration: 'underline',
      '&:hover, &:focus': {
        color: theme.colors.white,
        textDecoration: 'underline'
      }
    }
  },
  dotsGroupCenter: {
    margin: 'auto',
    marginTop: theme.spacing(5),
    [theme.breakpoints.up('md')]: {
      marginLeft: 0,
      marginBottom: theme.spacing(5),
      paddingLeft: theme.spacing(6)
    }
  },
  whiteDots: {
    marginTop: theme.spacing(4),
    marginBottom: theme.spacing(5),
    display: 'flex',
    justifyContent: 'center',
    [theme.breakpoints.up('md')]: {
      justifyContent: 'flex-start',
      paddingLeft: theme.spacing(6)
    },
    '& button': {
      width: 24,
      height: 34,
      padding: 8,
      margin: 5,
      border: 'none',
      display: 'inline-flex',
      alignItems: 'center',
      justifyContent: 'center',
      backgroundColor: 'transparent',
      borderRadius: '50%',
      outline: 'none',
      '& span': {
        width: 4,
        height: 4,
        backgroundColor: theme.colors.white,
        borderRadius: '50%',
        transform: 'scale(1)',
        transition: 'transform .4s'
      },
      '&.carousel__dot--selected span': {
        transform: 'scale(3)'
      }
    }
  },
  ipadDots: {
    [theme.breakpoints.up('md')]: {
      position: 'absolute',
      bottom: theme.spacing(2)
    }
  },
  watchDots: {
    [theme.breakpoints.up('md')]: {
      position: 'relative',
      bottom: -theme.spacing(1),
      paddingBottom: theme.spacing(2),
      marginBottom: 0
    }
  },
  imagesWrap: {
    width: 248,
    margin: 'auto',
    position: 'relative',
    marginBottom: (props) => (props.iPhone ? '-17rem' : props.iPad ? '-16rem' : '-9rem'),
    [theme.breakpoints.up('sm')]: {
      width: (props) => (props.iPad ? 420 : 315)
    },
    [theme.breakpoints.up('md')]: {
      marginRight: 0,
      marginBottom: (props) => (props.iPhone || props.iPad ? '0' : '-4rem')
    }
  },
  imagesWrapNormal: {
    width: '75vw',
    marginBottom: '-3rem',
    marginTop: '3rem',
    margin: 'auto',
    '& img': {
      maxWidth: '100%'
    },
    [theme.breakpoints.up('sm')]: {
      width: (props) => (props.homepage ? 'auto' : props.watch ? 477 : 400)
    },
    [theme.breakpoints.up('md')]: {
      width: 'auto',
      marginBottom: (props) => (props.iPhone || props.iPad ? '-11rem' : -theme.spacing(7)),
      marginRight: (props) => (props.watch ? 0 : 'auto')
    }
  },
  phoneImage: {
    width: 300,
    position: 'absolute',
    top: -51,
    left: -48,
    zIndex: 1,
    maxWidth: 'none',
    [theme.breakpoints.up('sm')]: {
      left: -50,
      top: -60,
      width: 'auto'
    }
  },
  iPadImage: {
    position: 'absolute',
    top: -10,
    left: -30,
    zIndex: 1,
    width: 290,
    maxWidth: 'none',
    [theme.breakpoints.up('sm')]: {
      width: 'auto'
    }
  },
  iphoneSlide: {
    width: '248px !important',

    '& img': {
      width: '100%'
    }
  },
  ipadSlide: {
    width: '248px !important',
    [theme.breakpoints.up('sm')]: {
      width: '390px !important'
    },
    '& > div': {
      alignItems: 'flex-start !important'
    },
    '& img': {
      width: '100%'
    }
  },
  fade: {
    animation: `.3s $fadeIn cubic-bezier(0.55, 0.09, 0.68, 0.53)`
  },
  '@keyframes fadeIn': {
    '0%': {
      opacity: 0,
      transform: 'translateX(20px)'
    },
    '100%': {
      opacity: 1,
      transform: 'translateX(0)'
    }
  },
  textPadding: {
    textAlign: 'center',
    [theme.breakpoints.up('md')]: {
      textAlign: 'left',
      paddingLeft: theme.spacing(6),
      display: 'flex',
      flexDirection: 'column',
      paddingTop: theme.spacing(4),
      minHeight: (props) => (props.minHeight ? props.minHeight + 'px' : '0')
    }
  },
  textBottom: {
    position: 'absolute',
    bottom: (props) => (props.iPhone ? '-20rem' : props.iPad ? '-20rem' : '-6rem'),
    zIndex: 2,
    color: theme.colors.colorTransparent6,
    textAlign: 'center',
    width: 'calc(100% - 4rem)',
    height: '3rem',
    [theme.breakpoints.up('md')]: {
      bottom: (props) => (props.iPhone ? '-2rem' : props.iPad ? '-2rem' : '-4rem'),
      textAlign: 'left',
      width: 'auto',
      '& p': {
        paddingLeft: theme.spacing(6)
      }
    },
    '& a': {
      color: theme.colors.blue1,
      textDecoration: 'none',
      fontWeight: 'bold',
      '&:hover': {
        color: '#67b2ce'
      }
    }
  },
  titleSmall: {
    textTransform: 'none',
    marginBottom: theme.spacing(2)
  },
  carouselImage: {
    display: 'block'
  },
  arrowback: {
    transform: 'rotate(180deg) translateX(2px)'
  }
}))

function TextItemContent(props) {
  const classes = useStyles(props)
  const current =
    props.currentSlide < props.totalSlides
      ? props.slideList[props.currentSlide - 1]
      : props.slideList[props.totalSlides - 1]
  const last = props.currentSlide === props.totalSlides

  const textStyle = clsx({
    [classes.textPadding]: true,
    [classes.fade]: props.fade
  })

  return (
    <>
      <div className={textStyle} onAnimationEnd={() => props.removeFade()}>
        <SectionHeaderSmall component="h1" gutterBottom className={classes.titleSmall}>
          {current.topTitle && uppercaseString(current.topTitle)}
        </SectionHeaderSmall>
        <TitleH2Bold component="h2" className={classes.overflowWords} gutterBottom>
          {current.title}
        </TitleH2Bold>
        <TitleMedium
          className={classes.textContent}
          component="div"
          dangerouslySetInnerHTML={{ __html: current.subtitle }}
        />

        <Typography
          className={classes.textContent}
          variant="body1"
          component="div"
          dangerouslySetInnerHTML={{ __html: current.content }}
        />

        {current.smallText && (
          <BodySmall
            className={classes.textContent}
            variant="body1"
            component="div"
            dangerouslySetInnerHTML={{ __html: current.smallText }}
          />
        )}

        {current.ctas && (
          <Box className={classes.ctas}>
            {current.ctas.map((button, i) => {
              return button.image ? (
                <Link
                  href={button.href}
                  rel={button.rel}
                  title={button.title}
                  target={button.openNewTab ? '_blank' : ''}
                  data-app-store={button.appStore}
                >
                  <GatsbyImage
                    image={button.image.gatsbyImageData}
                    alt={button.imageAlt}
                    height={45}
                  />
                </Link>
              ) : i === 0 && button.text ? (
                <Button
                  key={`carousel-button-${i}`}
                  variant="contained"
                  color="secondary"
                  href={button.href}
                  target={button.openNewTab ? '_blank' : ''}
                >
                  {button.text}
                </Button>
              ) : (
                button.text && (
                  <CustomButton
                    key={`carousel-button-${i}`}
                    variant="contained"
                    color="white"
                    href={button.href}
                    target={button.openNewTab ? '_blank' : ''}
                  >
                    {button.text}
                  </CustomButton>
                )
              )
            })}
          </Box>
        )}
        {props.iPad && (
          <ButtonNext className={classes.nextItem} onClick={props.handleFade}>
            <div className={classes.indexIcon}>{props.currentSlide}</div>
            {current.icon ? (
              <Button color={'inherit'} component="span">
                {placeImage(current.icon)}
                {current.nextButton}
                {!last && <ArrowForwardIosIcon fontSize="inherit" />}
              </Button>
            ) : (
              <Button color="white" component="span" className={classes.customWhite}>
                {current.nextButton}
                <ArrowForwardIosIcon fontSize="inherit" />
              </Button>
            )}
          </ButtonNext>
        )}
      </div>
    </>
  )
}

const TextItem = WithStore(TextItemContent, (state) => ({
  currentSlide: state.currentSlide + 1,
  totalSlides: state.totalSlides
}))

const Arrows = (props) => {
  const classes = useStyles(props)
  return (
    <Box>
      {props.currentSlide !== 1 && (
        <ButtonBack className={`${classes.buttons} ${classes.left}`}>
          <IconButton color={'inherit'} component="span" onClick={props.handleFade}>
            <ArrowForwardIosIcon className={classes.arrowback} fontSize="inherit" />
          </IconButton>
        </ButtonBack>
      )}
      {props.currentSlide !== props.totalSlides && (
        <ButtonNext className={`${classes.buttons} ${classes.right}`}>
          <IconButton color={'inherit'} component="span" onClick={props.handleFade}>
            <ArrowForwardIosIcon fontSize="inherit" />
          </IconButton>
        </ButtonNext>
      )}
    </Box>
  )
}

const NextPrevArrows = WithStore(Arrows, (state) => ({
  currentSlide: state.currentSlide + 1,
  totalSlides: state.totalSlides
}))

function TextWithVideoLink(props) {
  const [open, setOpen] = useState(false)

  const html = ReactHtmlParser(props.html, {
    transform: (node) => {
      if (node.name === 'a' && node.attribs && node.attribs.href) {
        let isVideo = false
        if (node.attribs.href.match(/(?:youtu\.be|youtube\.com)\/(?:watch\?v=)?([^&/]*)/i)) {
          isVideo = true
        } else if (node.attribs.href.match(/(?:vimeo\.com)\/([0-9]*)/i)) {
          isVideo = true
        }

        if (isVideo) {
          return (
            <>
              <VideoModal videoUrl={node.attribs.href} open={open} setOpen={setOpen}>
                <a
                  href="#"
                  onClick={(e) => {
                    e.preventDefault()
                    setOpen(true)
                  }}
                >
                  {node.children[0].data}
                </a>
              </VideoModal>
            </>
          )
        }
      }
      return undefined
    }
  })

  return (
    <div className={props.classes.textBottom} style={{ zIndex: 11 }}>
      {html}
    </div>
  )
}

function DevicesCarousel(props) {
  const classes = useStyles(props)
  const [fade, setFade] = useState(true)
  const [showAndroid, setShowAndroid] = useState(false)
  const desktop = useMediaQuery('(min-width: 960px)')

  useEffect(() => {
    var searchParams = new URLSearchParams(window.location.search)
    setShowAndroid(isAndroid || searchParams.get('device')?.toLowerCase() == 'android')
  }, [])

  let phoneOutline = <></>
  if (showAndroid && props.deviceImage) {
    phoneOutline = (
      <div className={`${classes.phoneImage}`}>
        <GatsbyImage image={props.deviceImage.gatsbyImageData} />
      </div>
    )
  } else if (props.iphoneImage) {
    phoneOutline = (
      <div className={props.iPad ? classes.iPadImage : classes.phoneImage}>
        <GatsbyImage image={props.iphoneImage.gatsbyImageData} />
      </div>
    )
  }

  const handleFade = () => {
    setFade(true)
  }
  const removeFade = () => {
    setFade(false)
  }

  const createDeviceNav = (slides) => {
    const { currentSlide, totalSlides, visibleSlides, disableActiveDots } = slides

    const dots = []
    for (let i = 0; i < totalSlides; i += 1) {
      const selected = i === currentSlide
      const slide = i >= totalSlides - visibleSlides ? totalSlides - visibleSlides : i

      const dotStyle = clsx({
        [classes.dot]: true,
        [classes.isSelected]: selected
      })

      dots.push(
        <Dot
          key={`dot-nav${i}`}
          slide={slide}
          selected={selected}
          disabled={disableActiveDots ? selected : false}
          className={dotStyle}
        >
          <Svg
            className={`${classes.whiteCircle} white-circle`}
            src={WhiteCircle}
            alt="white-circle"
          />
          <div className={`${classes.icon} icon`}>
            {placeImage(props.list[i].icon, { svg: true })}
          </div>
        </Dot>
      )
    }
    return dots
  }
  const dotGroupClass = clsx({
    [classes.whiteDots]: true,
    [classes.ipadDots]: props.iPad,
    [classes.watchDots]: props.watch
  })

  return (
    <ErrorBoundary>
      <CarouselProvider
        className={classes.root}
        naturalSlideWidth={props.iPhone ? 248 : props.iPad ? 412 : 1200}
        naturalSlideHeight={props.iPhone ? 580 : props.iPad ? 452 : 400}
        totalSlides={props.list.length}
        isIntrinsicHeight={true}
        infinite
        isPlaying={props.autoplay}
      >
        <Box style={{ position: 'relative' }}>
          <Grid container className={classes.gridContainer}>
            <Grid item md={6} xs={12} className={classes.textWrap}>
              <TextItem
                slideList={props.list}
                fade={fade}
                handleFade={handleFade}
                removeFade={removeFade}
                iPad={props.iPad}
                minHeight={props.minHeight}
              />
              {props.customDots ? (
                <DotGroup className={classes.dotsGroupCenter} renderDots={createDeviceNav} />
              ) : (
                <DotGroup className={dotGroupClass} onClick={handleFade} />
              )}

              {props.textBottom && <TextWithVideoLink html={props.textBottom} classes={classes} />}
            </Grid>

            <Grid item md={6} xs={12} className={classes.carouselImage}>
              <div
                className={
                  props.iPhone || props.iPad ? classes.imagesWrap : classes.imagesWrapNormal
                }
              >
                {phoneOutline}
                <Slider className={`${classes.minHeight} ${showAndroid ? classes.android : ''}`}>
                  {props.list.map((slide, i) => {
                    let image
                    if (showAndroid) {
                      image = props.iPhone
                        ? placeImage(slide.androidImage, { loading: 'lazy' })
                        : placeImage(slide.image, { loading: 'lazy' })
                    } else {
                      image = props.iPhone
                        ? placeImage(slide.iphoneImage, { loading: 'lazy' })
                        : placeImage(slide.image, { loading: 'lazy' })
                    }
                    return (
                      <Slide
                        index={i}
                        key={`banner-${i}`}
                        className={
                          props.iPhone
                            ? classes.iphoneSlide
                            : props.iPad
                            ? classes.ipadSlide
                            : classes.homepage
                        }
                      >
                        {image}
                      </Slide>
                    )
                  })}
                </Slider>
              </div>
            </Grid>
          </Grid>
          {desktop && props.list.length > 1 && (
            <NextPrevArrows handleFade={handleFade} iPad={props.iPad} />
          )}
        </Box>
      </CarouselProvider>
      <ModalComponent
        id="eid"
        isThin="true"
        title={props.modalTitle}
        content={props.modalContent}
        closeText={props.modalCloseText}
      />
    </ErrorBoundary>
  )
}

export default DevicesCarousel

DevicesCarousel.propTypes = {
  bgcolor: PropTypes.bool,
  list: PropTypes.arrayOf(
    PropTypes.shape({
      title: PropTypes.string,
      subtitle: PropTypes.string,
      image: PropTypes.string,
      image2: PropTypes.string,
      content: PropTypes.string,
      url: PropTypes.string
    })
  )
}

DevicesCarousel.defaultProps = {
  list: []
}
